import { Outlet } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function PageLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar variant="solid" />
      <main className="flex-1 pt-16">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}